import React, {
  useState,
  useContext,
  useEffect,
  useMemo,
  Fragment,
} from "react";

// cleaned wef 24 jul 23
// params cleared 10 sep 23
// preloaded images 19 sep 23
// axios caught 21 sep 23

import axios from "axios";
import { CalendarContext } from "../../../contexts/CalendarContext";
import { UserContext } from "../../../contexts/UserContext";
import { DataContext } from "../../../contexts/DataContext";
import { StyleContext } from "../../../contexts/StyleContext";

import dateStringer from "../../../tools/dateStringer";

import serverURL from "../../../serverURL";

import "../../../styles/calendar.css";

import horizontalBalls from "../../../img/loaders/horizontalBalls.svg";

import timesheetImg from "../../../img/general/ts.svg";
import teamIcon from "../../../img/general/teamIcon2.svg";

import ShiftsHeader from "./ShiftsHeader";
import HoursDatabox from "./HoursDataBox";

const Timesheets = ({ sideBoxData, my, setMy }) => {
  const { setCalPage } = useContext(CalendarContext);

  const { checkUserState } = useContext(UserContext);
  const { setShowTimesheet, setShowViewTimesheet, updateUserTimesheets } =
    useContext(DataContext);
  const { mob, full, fullButNarrow } = useContext(StyleContext);

  const memoVals = useMemo(
    () => ({
      setCalPage, //
      checkUserState, //
      setShowTimesheet, //
      setShowViewTimesheet, //
      updateUserTimesheets, //
      mob, //
      full, //
      fullButNarrow, //
    }),
    [
      setCalPage, //
      checkUserState, //
      setShowTimesheet, //
      setShowViewTimesheet, //
      updateUserTimesheets, //
      mob, //
      full, //
      fullButNarrow, //
    ]
  );

  document.title = "FlowRota - My timesheets";

  useEffect(() => {
    memoVals.setCalPage((x) => "shifts");
  }, []);
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params && params.timesheetID) {
      memoVals.setShowViewTimesheet((x) => {
        return {
          show: true,
          timesheetID: params.timesheetID,
          isMgr: false,
        };
      });

      let currentUrl = new URL(window.location.href);

      // Remove query parameters by setting search to an empty string
      currentUrl.search = "";

      // Update the URL without the query parameters
      window.history.replaceState({}, document.title, currentUrl.href);
    }
  }, []);

  // shifts, swaps, stats

  let [loading, setLoading] = useState(true);
  let [dataLoaded, setDataLoaded] = useState(false);
  let [imagesLoaded, setImagesLoaded] = useState(0);

  useEffect(() => {
    console.log({ dataLoaded, imagesLoaded });
    if (dataLoaded && imagesLoaded === 2) {
      setLoading(false);
    }
  }, [dataLoaded, imagesLoaded]);
  let imgPreload = (
    <div className="imagesHidden">
      {" "}
      <img
        src={timesheetImg}
        alt="Timesheet"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />{" "}
      <img
        src={teamIcon}
        alt="Timesheet"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
    </div>
  );
  let [yearsArr, setYearsArr] = useState([]);
  let [selectedYear, setSelectedYear] = useState(
    memoVals.checkUserState.currClientYear
  );
  const cancelSource1 = axios.CancelToken.source();

  useEffect(() => {
    if (!yearsArr[1]) {
      axios
        .post(
          `${serverURL}/get-available-years`,
          {
            userOnly: true,
          },

          {
            withCredentials: true,
            credentials: "include",
            cancelToken: cancelSource1.token,
          }
        )
        .then((response) => {
          if (response.data.message === "success") {
            setYearsArr(response.data.availableYears || []);
          }
        })
        .catch((e) => {
          console.error("ERR", e);
        });
    }

    return () => {
      cancelSource1.cancel("Component unmounted");
    };
  }, []);

  let [tsArr, setTsArr] = useState([]);

  const cancelSource2 = axios.CancelToken.source();

  useEffect(() => {
    axios
      .post(
        `${serverURL}/get-timesheets`,
        {
          year: selectedYear,
        },

        {
          withCredentials: true,
          credentials: "include",
          cancelToken: cancelSource2.token,
        }
      )
      .then((response) => {
        if (response.data.message === "success") {
          let pending = [];
          let nonPending = [];
          response.data.output
            .sort((a, b) => {
              return b.startTs - a.startTs;
            })
            .forEach((item) => {
              if (!item.submitted) {
                pending.push(item);
              } else {
                nonPending.push(item);
              }
            });
          if (pending[0]) {
            pending.push({ split: true });
          } else {
          }
          setTsArr([...pending, , ...nonPending]);
          setDataLoaded(true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    return () => {
      cancelSource2.cancel("Component unmounted");
    };
  }, [selectedYear, memoVals.updateUserTimesheets]);

  let generateTimesheets = useMemo(() => {
    return tsArr.map((ts, i) => {
      let dateString = !ts.split ? (
        <>
          {" "}
          {dateStringer.printedDateFromDs(
            ts.startDs,
            false,
            false,
            "tsSuff"
          )}{" "}
          {ts.startDs !== `${ts.endDs.substr(0, 11)}H00M00` && ts.submitted
            ? "-"
            : ""}{" "}
          {ts.startDs !== `${ts.endDs.substr(0, 11)}H00M00` && ts.submitted
            ? dateStringer.printedDateFromDs(ts.endDs, false, false, "tsSuff")
            : ""}{" "}
          {!ts.submitted ? (
            <Fragment>
              <span className="tsUpToTodaySpan"> up to</span> today
            </Fragment>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      );

      let makeSmaller = false;
      if (
        !ts.split &&
        (memoVals.mob || memoVals.fullButNarrow) &&
        ts.startDs !== `${ts.endDs.substr(0, 11)}H00M00`
      ) {
        makeSmaller = true;
      }

      if (ts.split) {
        return <div className="pendingTsSplitter" key={i}></div>;
      } else {
        return (
          <div
            key={i}
            className={`mgrReqItem tsItemUnit ${mob ? "borderRadius10" : ""} ${
              !ts.submitted ? "mgrReqItemPendingBorder" : ""
            } ${!ts.approved && !ts.declined ? "pendClock" : ""}`}
            onClick={() => {
              console.log({ ts });
              if (ts.submitted) {
                memoVals.setShowViewTimesheet((x) => {
                  return {
                    show: true,
                    timesheetID: ts.timesheetID,
                    isMgr: false,
                  };
                });
              } else {
                memoVals.setShowTimesheet((x) => {
                  return {
                    timesheetID: ts.timesheetID,
                  };
                });
              }
            }}
          >
            <div
              className={`tsUnitLeft ${
                !ts.submitted ? "tsUnitLeftNonSubmitted" : ""
              }`}
            >
              {!ts.submitted ? <div className="unsubmittedTsBlob"></div> : ""}
              <img
                src={timesheetImg}
                alt="Timesheet"
                className={`tsUnitImg ${!ts.submitted ? "x308491" : ""} ${
                  memoVals.mob ? "tsUnitImgMob" : ""
                }`}
              />
            </div>
            <div
              className={`reqColBarDiv reqColBarAdjust5 ${
                ts.approved ? "" : "divPend"
              } ${ts.declined ? "divDec" : ""}`}
            ></div>
            <div
              className={`tsUnitMiddle ${
                memoVals.mob ? "tsUnitMiddleMob" : ""
              } ${!ts.submitted ? "pendingReqBord" : ""}`}
            >
              <div className="tsUnitMidLeft">
                <div
                  className={`tsFromTilSection ${
                    !ts.approved && !ts.declined ? "x32897478243" : ""
                  }`}
                >
                  <div className="tsUnitFromToSection">
                    {/* <p className="tsUnitDsTitle">From</p> */}
                    <div
                      className={`tsUnitDsValue ${
                        memoVals.mob ? "tsUnitDsValueMob" : ""
                      } ${makeSmaller ? "x208492" : ""}`}
                    >
                      {dateString}
                    </div>
                  </div>
                  {/* <div className="tsUnitFromToSection">
                  <p className="tsUnitDsTitle">Until</p>
                  <p
                    className={`tsUnitDsValue ${memoVals.mob ? "tsUnitDsValueMob" : ""}`}
                  >
                    {dateStringer.printedDateFromDs(ts.endDs)}
                  </p>
                </div> */}
                </div>
                <div className={`tsUnitTeamName `}>
                  <img src={teamIcon} alt="Team" className="teamIconTs" />{" "}
                  {dateStringer.shorten(
                    ts.teamName,
                    memoVals.mob || memoVals.fullButNarrow ? 20 : 20
                  )}
                  {!ts.approved && !ts.declined && ts.submitted ? (
                    <p
                      className={`submittedTsBadge notYetSub ${
                        memoVals.mob ? "tsBadMob" : ""
                      }`}
                    >
                      Submitted
                      {/* <span className="smallSubmitBadgeSpan">Submitted</span>
                    {memoVals.mob ? <br /> : " "}
                    {dateStringer.printedDateFromDs(ts.submitted)} */}
                    </p>
                  ) : (
                    ""
                  )}
                  {ts.declined ? (
                    <p
                      className={`submittedTsBadge notYetSub declinedTsCol ${
                        memoVals.mob ? "tsBadMob" : ""
                      }`}
                    >
                      Declined
                      {/* <span className="smallSubmitBadgeSpan">Submitted</span>
                    {memoVals.mob ? <br /> : " "}
                    {dateStringer.printedDateFromDs(ts.submitted)} */}
                    </p>
                  ) : (
                    ""
                  )}
                  {ts.approved ? (
                    <p
                      className={`submittedTsBadge notYetSub approvedTsCol ${
                        memoVals.mob ? "tsBadMob" : ""
                      }`}
                    >
                      Approved
                      {/* <span className="smallSubmitBadgeSpan">Submitted</span>
                    {memoVals.mob ? <br /> : " "}
                    {dateStringer.printedDateFromDs(ts.submitted)} */}
                    </p>
                  ) : (
                    ""
                  )}
                  {/* {!ts.approved && !ts.declined && !ts.submitted ? (
                      <p
                        className={`submittedTsBadge notYetSub  ${
                          memoVals.mob ? "tsBadMob" : ""
                        }`}
                      >
                        Yet to submit
                      </p>
                    ) : (
                      ""
                    )} */}
                </div>
              </div>
              <div className="tsUnitMidRight">
                <div className="tsUnitFromToSection x1341">
                  <p className="tsUnitDsTitle">Records</p>
                  <p className="tsUnitDsValue">{ts.itemsQty}</p>
                </div>
              </div>
            </div>
            <div className="itemTongue tsTongue">
              <p className="tongueTxt clockTongueTxt">Timesheet</p>
            </div>
            {/* <div className="tsUnitRight"></div> */}
          </div>
        );
      }
    });
  }, [tsArr, memoVals.mob, memoVals.fullButNarrow]);

  let generateYearsArr = useMemo(() => {
    yearsArr.sort();
    return (
      yearsArr &&
      yearsArr.map((year, i) => {
        return (
          <option key={i} value={year}>
            {year}
          </option>
        );
      })
    );
  }, [yearsArr]);

  // ------------------------------------------------------------------------

  return (
    <div
      className={`userShiftsPage ${memoVals.mob ? "" : "pageLeft240pxDesktop"}`}
    >
      {" "}
      {/* insert header here */}
      <ShiftsHeader my={my} setMy={setMy} />
      <div className={`desktopMaster ${memoVals.mob ? "desktopWhiteBg" : ""}`}>
        <div
          className={`desktopMasterMain ${
            !memoVals.full && !memoVals.mob ? "midContentWidth" : ""
          } ${memoVals.mob ? "mob100Witdth" : ""} `}
        >
          <div
            className={`shiftsPageFilterBar ${
              memoVals.mob ? "userHoursShoulderBar2 " : ""
            } ${!memoVals.mob && "borderLeftGrey"}`}
          >
            <div className="shiftsPageFilterBarLeft">
              <select
                className={`myReqsYearDropdown`}
                value={selectedYear}
                onChange={(e) => {
                  if (e.target.value) {
                    setLoading(true);
                    setSelectedYear(parseInt(e.target.value));
                  }
                }}
              >
                {!yearsArr.includes(selectedYear) ? (
                  <option value="">--</option>
                ) : (
                  ""
                )}
                {generateYearsArr}
              </select>
            </div>
            <div className="shiftsPageFilterBarRight"></div>
          </div>

          <div
            className={`filterSplitterContainer ${
              !memoVals.mob && "borderLeftGrey"
            } ${!memoVals.full ? "noBorderRight" : ""}`}
          >
            <div className="filterSplitter"></div>
          </div>

          <div
            className={`tsContainer ${!memoVals.full ? "noBorderRight" : ""} ${
              memoVals.mob ? "mobTsContainer" : ""
            }`}
          >
            <img
              src={horizontalBalls}
              className={`${loading ? "loadingHoriztonalImg" : "none"}`}
              alt="Loading"
            />

            {/* {!loading && notYetSubmittedExists ? (
              <p className="clocksAwaitingTitles notYetSubmitTitleArr">
                Not yet submitted
              </p>
            ) : (
              ""
            )} */}
            {!loading ? generateTimesheets : ""}
            {!loading && tsArr.length === 0 ? (
              <div
                className={`noShiftsTxtContainer noUpcomingReqs ${
                  memoVals.mob ? "x1984971" : ""
                }`}
              >
                <div className="noShiftsSideBar"></div>

                <p
                  className={`noShiftsTxt x19873`}
                  onClick={() => {
                    console.log(tsArr);
                  }}
                >
                  No timesheets created in {selectedYear}
                </p>

                <div className="noShiftsSideBar"></div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div
          className={`${
            memoVals.mob || !memoVals.full ? "none" : "desktopMasterSecondary"
          }`}
        >
          <HoursDatabox sideBoxData={sideBoxData} my={my} setMy={setMy} />{" "}
        </div>
      </div>
      {imgPreload}
    </div>
  );
};

export default Timesheets;
